export default "__VITE_ASSET__43a22943__"